import type { WebsiteHealthSummary } from "contracts/api/website/responses";
import { healthVar } from "../../ui/health";

export function PaletteItem(props: {
  site: WebsiteHealthSummary;
  selected: boolean;
  onChoose: () => void;
}) {
  return (
    <button
      class={`palette-item ${props.selected ? "on" : ""}`}
      type="button"
      onClick={props.onChoose}
    >
      <span
        class="health-pip"
        style={{ background: healthVar(props.site.healthState) }}
      />
      <div>
        <div class="palette-item-name">
          {props.site.displayName ?? props.site.clientName}
        </div>
        <div class="palette-item-sub">{props.site.domain}</div>
      </div>
      <span class="palette-item-score">
        {props.site.signalScore === null ? "—" : props.site.signalScore}
      </span>
    </button>
  );
}
